import { defineMessages } from 'react-intl';

export default defineMessages({
    addVehicleTitle: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Add a vehicle',
        defaultMessage: 'Add a vehicle'
    },
    editVehicleTitle: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Edit a vehicle',
        defaultMessage: 'Edit a vehicle'
    },
    subtitle: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Enter your make and model details',
        defaultMessage: 'Enter your make and model details'
    },
    describeOther: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Describe Other',
        defaultMessage: 'Describe Other'
    },
    vehicleType: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    Year: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Year',
        defaultMessage: 'Year'
    },
    Make: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Make',
        defaultMessage: 'Make'
    },
    Model: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Model',
        defaultMessage: 'Model'
    },
    BodyType: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Body Type',
        defaultMessage: 'Body Type'
    },
    Trim: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Trim',
        defaultMessage: 'Trim'
    },
    LicenseState: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.License State',
        defaultMessage: 'License State'
    },
    SerialNumber: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Serial Number',
        defaultMessage: 'Serial Number'
    },
    findSerialNumber: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Where do I find my VIN/Serial Number?',
        defaultMessage: 'Where do I find my VIN/Serial Number?'
    },
    findVin: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Where do I find my VIN?',
        defaultMessage: 'Where do I find my VIN?'
    },
    SerialNumberTooltip: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Serial Number Tooltip',
        defaultMessage: 'The VIN (vehicle identification number) or serial number is used by the auto industry to identify individual motor vehicles.  By entering the VIN, we can automatically validate the specifics of the vehicle and provide a more accurate car insurance quote, including applicable discounts.  The VIN can be found in several places on a vehicle including the driver’s side dashboard and driver’s side doorjamb.   The serial number on a snowmobile is typically located on the right side of the tunnel and for most golf carts, the serial number is located by the glove box.  On a motorcycle, the VIN is typically located on the steering neck or on the motor near the bottom of the cylinders.'
    },
    CCs: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.CCs',
        defaultMessage: 'CCs'
    },
    Horsepower: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Horsepower',
        defaultMessage: 'Horsepower'
    },
    MyPolicyInfo: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.My Policy Info',
        defaultMessage: 'My Policy Info'
    },
    Whatdoesthismean: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    excludeVehicleTooltip: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.You have chosen to exclude this vehicle from coverage under your Umbrella policy.',
        defaultMessage: 'You have chosen to exclude this vehicle from coverage under your Umbrella policy.'
    },
    vehicleTypeTooltipHeader: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Which vehicle type should I select?',
        defaultMessage: 'Which vehicle type should I select?'
    },
    vehicleTypeTooltipContent: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Vehicle Type Tooltip Content',
        defaultMessage: '<p>• Private Passenger/light truck if you have the following:  private passenger auto including a station wagon.</p><p>• Pickup Truck if you have a light duty truck with an enclosed cab and open cargo area.</p><p>• Van/SUV if you have a van that can transport people or goods but does not need a commercial or special driver’s license to operate or if you have a sport utility vehicle that is operated as a family vehicle.</p><p>• Panel Truck if you have a vehicle which is a small enclosed van with a rear cargo area typically used for transporting or delivering goods.</p><p>• Flat-Bed or Box Truck if you have a flatbed truck with an entirely flat, level bed with no sides or roof or a box truck with a fully enclosed box designed to transport cargo.  These are vehicles which do not require a commercial or special driver’s license to operate.</p><p>• Collectible if you have a vehicle which is unique or vintage and is collectible in nature.   Categories for collectible vehicles include:</p><p>Antique – Vehicles which are 1) licensed as an antique with the Department of Motor Vehicles; or 2) 25 years old or older and in running condition.  Vehicles may be driven only on a limited basis.  Vehicles kept only for use as parts are not eligible. </p><p>Classic – Vehicles that are at least 10 years old and of limited production or of rare or historic interest through being restored, maintained or preserved.  These vehicles appreciate in value (from their original price new) as they become older.</p><p>Replica – Reproductions of an antique or classic vehicle.  Generally following the design and features of an older out of production vehicle, but manufactured and assembled with newer parts and equipment. </p><p>Custom – A vehicle which has been custom built, including kit cars, or has been significantly modified from its original specifications. </p><p>• Low Speed Vehicle if you have a low speed vehicle or neighborhood electric vehicle (NEV).  In most states, vehicles are considered low speed when they are less than 35 miles per hour.</p><p>• Golf cart which is small motorized vehicle for golfers and their equipment.</p><p>• ATV/Snowmobile if you have an four-wheel all-terrain vehicle or a snowmobile.</p><p>• Trailers do not need to be added to the umbrella policy.  Liability coverage automatically extends to a trailer, as long as the vehicle pulling it is covered under the umbrella.</p>'
    },
    vehicleTypeTooltipContentNH: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Vehicle Type Tooltip Content NH',
        defaultMessage: '<p>• Private Passenger/light truck if you have the following:  private passenger auto including a station wagon.</p><p>• Pickup Truck if you have a light duty truck with an enclosed cab and open cargo area.</p><p>• Van/SUV if you have a van that can transport people or goods but does not need a commercial or special driver’s license to operate or if you have a sport utility vehicle that is operated as a family vehicle.</p><p>• Panel Truck if you have a vehicle which is a small enclosed van with a rear cargo area typically used for transporting or delivering goods.</p><p>• Flat-Bed or Box Truck if you have a flatbed truck with an entirely flat, level bed with no sides or roof or a box truck with a fully enclosed box designed to transport cargo.  These are vehicles which do not require a commercial or special driver’s license to operate.</p><p>• Collectible if you have a vehicle which is unique or vintage and is collectible in nature.   Categories for collectible vehicles include:</p><p>Antique – Vehicles which are 1) licensed as an antique with the Department of Motor Vehicles; or 2) 25 years old or older and in running condition.  Vehicles may be driven only on a limited basis.  Vehicles kept only for use as parts are not eligible. </p><p>Classic – Vehicles that are at least 10 years old and of limited production or of rare or historic interest through being restored, maintained or preserved.  These vehicles appreciate in value (from their original price new) as they become older.</p><p>Replica – Reproductions of an antique or classic vehicle.  Generally following the design and features of an older out of production vehicle, but manufactured and assembled with newer parts and equipment. </p><p>Custom – A vehicle which has been custom built, including kit cars, or has been significantly modified from its original specifications. </p><p>• Low Speed Vehicle if you have a low speed vehicle or neighborhood electric vehicle (NEV).  In most states, vehicles are considered low speed when they are less than 35 miles per hour.</p><p>• Golf cart which is small motorized vehicle for golfers and their equipment.</p><p>• ATV/Snowmobile if you have an four-wheel all-terrain vehicle or a snowmobile.</p><p>• Trailers do not need to be added to the umbrella policy.  Liability coverage automatically extends to a trailer, as long as the vehicle pulling it is covered under the umbrella.</p><p></p><p>• Other Personally Registered Vehicles:  Vehicles registered for use on public roads, which are not Private Passenger Autos; Pickups; Vans; Motorcycles; Motorhomes; Off-Road Recreational Vehicles, such as golf carts, ATVs, and snowmobiles; or Collectible or Antique cars, trucks, and motorcycles.  Examples include armored military vehicles, tanks, and amphibious automobiles.</p>"'
    },
    actionbuttonLabelContinue: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.actionbuttonLabelContinue',
        defaultMessage: 'CONTINUE'
    },
    vinResponseEnterYear: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.vinResponse.We are unable to validate the model year of your vehicle, please enter model year',
        defaultMessage: 'We are unable to validate the model year of your vehicle, please enter model year'
    },
    vinResponseInValid: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.vinResponse.inValidVIN',
        defaultMessage: ' is invalid. Please confirm the VIN listed is accurate, then enter the Vehicle Type, Year, Make, and Model and select Lookup VIN. If the model is not listed in the dropdown, please click Model Not Listed and enter the required fields.'
    },
    OrSimplyEnterVin: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.OR simply enter the VIN number',
        defaultMessage: 'OR simply enter the VIN'
    },
    vinHelpTextMessage: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.vinHelpTextMessage',
        defaultMessage: 'The VIN (vehicle identification number) is  used by the auto industry to identify individual motor vehicles.  By entering the VIN, we can automatically validate the specifics of the vehicle and provide a more accurate car insurance quote, including applicable discounts.  The VIN can be found in several places on a vehicle including the driver’s side dashboard and driver’s side doorjamb.'
    },
    vinHelpTextHeader: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.vinHelpTextHeader',
        defaultMessage: 'Vehicle Identification Number Information'
    },
    addVehicleWithVin: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Add with my VIN',
        defaultMessage: 'Add with my VIN'
    },
    vin: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.VIN Number',
        defaultMessage: 'VIN'
    },
    enterVin: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Enter VIN',
        defaultMessage: 'Enter VIN'
    },
    looupVin: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.LOOKUP VIN',
        defaultMessage: 'LOOKUP VIN'
    },
    wantToExclude: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Do you want to exclude this vehicle?',
        defaultMessage: 'Do you want to exclude this vehicle?'
    },
    VinSerialNumber: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.VIN/Serial Number',
        defaultMessage: 'VIN/Serial Number'
    },
    duplicatedVins: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.This VIN number has already been listed for another vehicle',
        defaultMessage: 'This VIN has already been listed for another vehicle'
    },
    addVehicleExposureTitle: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.Add Vehicle Exposure',
        defaultMessage: 'Add Vehicle Exposure'
    },
    editVehicleExposureTitle: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.Edit Vehicle Exposure',
        defaultMessage: 'Edit Vehicle Exposure'
    },
    Cancel: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.CANCEL',
        defaultMessage: 'CANCEL'
    },
    AddVehicleButton: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.ADD VEHICLE',
        defaultMessage: 'ADD VEHICLE'
    },
    EditVehicleButton: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.EDIT VEHICLE',
        defaultMessage: 'EDIT VEHICLE'
    },
    VerifyVin: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.VERIFY VIN',
        defaultMessage: 'VERIFY VIN'
    },
    vinNumber: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.VIN Number',
        defaultMessage: 'VIN'
    },
    licenseStateTooltipTitle: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    licenseStateTooltipText: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.License state is the state where the vehicle is registered and the state on your license plates.',
        defaultMessage: 'License state is the state where the vehicle is registered and the state on your license plates.'
    },
    invalidVinError: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.Invalid VIN Please try again',
        defaultMessage: 'Invalid VIN Please try again'
    },
    duplicatedVinError: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.VIN number already exists on another vehicle, please update VIN',
        defaultMessage: 'VIN already exists on another vehicle, please update VIN'
    },
    nonOwnerPolicyError: {
        id: 'ml.quoteandbuy.pup.exposures.addVehicle.You are not able to add a vehicle as a Non-Owner Policy was selected for the Umbrella Underlying policy. To proceed, remove the vehicle or update Policy information.',
        defaultMessage: 'You are not able to add a vehicle as a Non-Owner Policy was selected for the Umbrella Underlying policy. To proceed, remove the vehicle or update Policy information.'
    },
    requiredField: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.This is required',
        defaultMessage: 'This is required'
    },
    underlyingPolicy: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Underlying Policy',
        defaultMessage: 'Underlying Policy'
    },
    vinOrSerialNumberRequired: {
        id: 'ml.quoteandbind.pup.exposures.addVehicle.Vin Or Serial Number Required ',
        defaultMessage: 'VIN or Serial Number required when Vehicle Type is "Other"'
    }
});
